/* Vidéos créateurs et clients (09/10).
   1. Cartes : aperçu muet qui bouge seul (6 premières secondes en boucle), seulement
      pour les cartes à l'écran, 3 au plus en même temps. Coupé si économie de données
      ou « réduire les animations ».
   2. Lecteur : un toucher ouvre la vidéo en grand, avec le son. Glisser ou flèches pour
      la suivante, toucher pour pause, bouton son, bouton plein écran, bouton d'achat. */
(function () {
  'use strict';
  var section = document.querySelector('[data-kxv]');
  if (!section || section.__kxv) return;
  section.__kxv = true;

  var cards = [].slice.call(section.querySelectorAll('.kxv__card'));
  var track = section.querySelector('.kxv__track');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var MAX_LIVE = 3, PREVIEW_S = 6;

  /* ---------- Flèches du rail ---------- */
  [].forEach.call(section.querySelectorAll('[data-kxv-dir]'), function (b) {
    b.addEventListener('click', function () {
      var c = cards[0];
      var step = c ? (c.getBoundingClientRect().width + 12) * 2 : 300;
      track.scrollBy({ left: step * parseInt(b.getAttribute('data-kxv-dir'), 10), behavior: 'smooth' });
    });
  });

  /* ---------- Aperçus animés ---------- */
  var visible = new Set();
  var live = new Map();
  var lbOpen = false;

  function stopPreview(card) {
    var v = live.get(card);
    if (!v) return;
    live.delete(card);
    card.classList.remove('is-live');
    try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
    if (v.parentNode) v.parentNode.removeChild(v);
  }
  function startPreview(card) {
    if (live.has(card)) return;
    var v = document.createElement('video');
    v.className = 'kxv__vid';
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.setAttribute('aria-hidden', 'true'); v.preload = 'auto';
    v.src = card.getAttribute('data-src');
    v.addEventListener('playing', function () { card.classList.add('is-live'); });
    v.addEventListener('timeupdate', function () { if (v.currentTime >= PREVIEW_S) v.currentTime = 0; });
    v.addEventListener('ended', function () { v.currentTime = 0; v.play().catch(function () {}); });
    card.querySelector('.kxv__open').insertBefore(v, card.querySelector('.kxv__shade'));
    live.set(card, v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { stopPreview(card); });
  }
  function refresh() {
    if (reduce || saveData || lbOpen || document.hidden) { live.forEach(function (_, c) { stopPreview(c); }); return; }
    var want = cards.filter(function (c) { return visible.has(c); }).slice(0, MAX_LIVE);
    live.forEach(function (_, c) { if (want.indexOf(c) < 0) stopPreview(c); });
    want.forEach(startPreview);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) visible.add(e.target); else visible.delete(e.target); });
      refresh();
    }, { threshold: [0, 0.6, 1] });
    cards.forEach(function (c) { io.observe(c); });
  }
  document.addEventListener('visibilitychange', refresh);

  /* Petit élan du rail la première fois qu'il apparaît (montre qu'on peut glisser). */
  if (!reduce && 'IntersectionObserver' in window) {
    var nudge = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      nudge.disconnect();
      setTimeout(function () {
        if (track.scrollLeft > 4) return;
        track.scrollBy({ left: 56, behavior: 'smooth' });
        setTimeout(function () { track.scrollBy({ left: -56, behavior: 'smooth' }); }, 650);
      }, 700);
    }, { threshold: 0.5 });
    nudge.observe(track);
  }

  /* ---------- Lecteur grand format ---------- */
  var ctaUrl = section.getAttribute('data-cta-url');
  var ctaLabel = section.getAttribute('data-cta-label');
  var lb = document.createElement('div');
  lb.className = 'kxv-lb';
  lb.hidden = true;
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Lecteur vidéo');
  lb.innerHTML =
    '<div class="kxv-lb__stage">' +
      '<img class="kxv-lb__poster" alt="">' +
      '<video class="kxv-lb__video" playsinline webkit-playsinline preload="auto"></video>' +
      '<span class="kxv-lb__spin" aria-hidden="true"></span>' +
      '<button type="button" class="kxv-lb__tap" aria-label="Pause ou lecture"></button>' +
      '<span class="kxv-lb__pauseic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>' +
      '<div class="kxv-lb__top">' +
        '<div class="kxv-lb__bar"><i></i></div>' +
        '<div class="kxv-lb__row"><span class="kxv-lb__count"></span>' +
        '<button type="button" class="kxv-lb__close" aria-label="Fermer la vidéo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '</div>' +
      '<button type="button" class="kxv-lb__nav kxv-lb__nav--prev" aria-label="Vidéo précédente"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="kxv-lb__nav kxv-lb__nav--next" aria-label="Vidéo suivante"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="kxv-lb__bottom">' +
        '<div class="kxv-lb__info"><span class="kxv-lb__who"></span><span class="kxv-lb__aud"></span></div>' +
        '<div class="kxv-lb__tools">' +
          '<button type="button" class="kxv-lb__tool kxv-lb__son" aria-pressed="true" aria-label="Couper le son"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path class="kxv__w" d="M16.5 8.5a5 5 0 0 1 0 7"/><path class="kxv__w" d="M19 6a8.5 8.5 0 0 1 0 12"/><path class="kxv-lb__x" d="M16 9l6 6M22 9l-6 6"/></svg></button>' +
          '<button type="button" class="kxv-lb__tool kxv-lb__fs" aria-label="Plein écran"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg></button>' +
        '</div>' +
        '<a class="kxv-lb__cta" href="#"></a>' +
      '</div>' +
    '</div>';
  document.body.appendChild(lb);

  var stage = lb.querySelector('.kxv-lb__stage');
  var vid = lb.querySelector('.kxv-lb__video');
  var poster = lb.querySelector('.kxv-lb__poster');
  var bar = lb.querySelector('.kxv-lb__bar i');
  var countEl = lb.querySelector('.kxv-lb__count');
  var whoEl = lb.querySelector('.kxv-lb__who');
  var audEl = lb.querySelector('.kxv-lb__aud');
  var sonBtn = lb.querySelector('.kxv-lb__son');
  var cta = lb.querySelector('.kxv-lb__cta');
  cta.textContent = ctaLabel;
  cta.href = ctaUrl === '#offre' ? '#' : ctaUrl;

  var idx = 0, muted = false, lastFocus = null, scrollY = 0;

  function setMuted(m) {
    muted = m; vid.muted = m;
    lb.classList.toggle('is-muted', m);
    sonBtn.setAttribute('aria-pressed', m ? 'false' : 'true');
    sonBtn.setAttribute('aria-label', m ? 'Activer le son' : 'Couper le son');
  }
  function load(i) {
    idx = (i + cards.length) % cards.length;
    var c = cards[idx];
    lb.classList.remove('is-playing', 'is-paused');
    lb.classList.add('is-loading');
    poster.src = c.querySelector('.kxv__poster').currentSrc || c.querySelector('.kxv__poster').src;
    whoEl.textContent = c.getAttribute('data-who');
    audEl.textContent = c.getAttribute('data-aud');
    countEl.textContent = (idx + 1) + ' / ' + cards.length;
    bar.style.transform = 'scaleX(0)';
    vid.src = c.getAttribute('data-src');
    vid.muted = muted;
    var p = vid.play();
    if (p && p.catch) p.catch(function () {
      /* le navigateur refuse le son sans geste : on lance en muet, le bouton son reste visible */
      setMuted(true);
      var q = vid.play(); if (q && q.catch) q.catch(function () { lb.classList.add('is-paused'); lb.classList.remove('is-loading'); });
    });
    var n = cards[(idx + 1) % cards.length];
    if (n) { var im = new Image(); im.src = n.querySelector('.kxv__poster').src; }
  }
  function open(i) {
    lbOpen = true; refresh();
    lastFocus = document.activeElement;
    scrollY = window.scrollY;
    lb.hidden = false;
    document.documentElement.classList.add('kxv-lock');
    void lb.offsetWidth; /* force le rendu avant l'ouverture en fondu */
    lb.classList.add('is-open');
    setMuted(false);
    load(i);
    lb.querySelector('.kxv-lb__close').focus({ preventScroll: true });
    try { history.pushState({ kxv: 1 }, ''); } catch (e) {}
  }
  function close(fromPop) {
    if (lb.hidden) return;
    try { vid.pause(); vid.removeAttribute('src'); vid.load(); } catch (e) {}
    if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {});
    lb.classList.remove('is-open', 'is-playing', 'is-paused', 'is-loading');
    lb.hidden = true;
    document.documentElement.classList.remove('kxv-lock');
    window.scrollTo(0, scrollY);
    lbOpen = false; refresh();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (!fromPop) { try { if (history.state && history.state.kxv) history.back(); } catch (e) {} }
  }
  window.addEventListener('popstate', function () { close(true); });

  vid.addEventListener('playing', function () { lb.classList.remove('is-loading', 'is-paused'); lb.classList.add('is-playing'); });
  vid.addEventListener('waiting', function () { lb.classList.add('is-loading'); });
  vid.addEventListener('pause', function () { if (!lb.hidden && !vid.ended) lb.classList.add('is-paused'); });
  vid.addEventListener('timeupdate', function () {
    if (vid.duration) bar.style.transform = 'scaleX(' + Math.min(1, vid.currentTime / vid.duration) + ')';
  });
  vid.addEventListener('ended', function () { load(idx + 1); });

  cards.forEach(function (c, i) {
    c.querySelector('.kxv__open').addEventListener('click', function () { open(i); });
  });
  lb.querySelector('.kxv-lb__close').addEventListener('click', function () { close(false); });
  lb.querySelector('.kxv-lb__nav--prev').addEventListener('click', function () { load(idx - 1); });
  lb.querySelector('.kxv-lb__nav--next').addEventListener('click', function () { load(idx + 1); });
  lb.querySelector('.kxv-lb__tap').addEventListener('click', function () {
    if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause();
  });
  sonBtn.addEventListener('click', function () {
    setMuted(!muted);
    if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
  });
  lb.querySelector('.kxv-lb__fs').addEventListener('click', function () {
    if (stage.requestFullscreen && document.fullscreenEnabled) {
      if (document.fullscreenElement) document.exitFullscreen(); else stage.requestFullscreen().catch(function () {});
    } else if (vid.webkitEnterFullscreen) {
      vid.webkitEnterFullscreen(); /* iPhone : plein écran natif de la vidéo */
    }
  });
  cta.addEventListener('click', function (e) {
    if (ctaUrl !== '#offre') return;
    e.preventDefault();
    close(false);
    var target = document.querySelector('.pdp') || document.body;
    setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  });
  lb.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close(false);
    else if (e.key === 'ArrowRight') load(idx + 1);
    else if (e.key === 'ArrowLeft') load(idx - 1);
    else if (e.key === 'Tab') {
      var f = [].slice.call(lb.querySelectorAll('button, a')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  /* Glisser : gauche/droite = vidéo suivante/précédente, vers le bas = fermer */
  var sx = 0, sy = 0, st = 0;
  stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (Date.now() - st > 800) return;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) load(idx + (dx < 0 ? 1 : -1));
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close(false);
  }, { passive: true });
})();
